<div class="position-relative">
  @if (isLoading || isSaving) {
    <loader [config]="{ type: 'spinner', overlay: true, size: 'md', text: isSaving ? 'Saving...' : '' }"></loader>
  }

  <a href="javascript:void(0);" class="finance-back-link d-inline-block mb-3" (click)="cancel()">
    <i class="fa fa-solid fa-chevron-left me-1"></i>Back to Finance Analysis
  </a>

  <div class="finance-panel">
    <div class="finance-panel-header">
      <div>
        <h5 class="finance-panel-title">{{ isEditMode ? 'Edit Testing Cost' : 'Add Testing Cost' }}</h5>
        <small class="text-muted">
          Testing Costs — manual entry of hours worked per resource.
        </small>
      </div>
    </div>

    <div class="finance-panel-body">
      <form [formGroup]="form" class="row justify-content-center">
        <div class="col-xl-8 col-lg-10">
          <div class="row">
            <div class="col-12 mb-3">
              <select-field
                label="Resource / User"
                [selectFormControl]="getControl('resourceUserId')"
                [options]="resourceOptions">
              </select-field>
            </div>

            <div class="col-md-6">
              <input-field
                label="Hours Worked"
                placeholder="0"
                [inputFormControl]="getControl('hoursWorked')"
                [type]="'number'"
                [readonly]="false">
              </input-field>
            </div>
            <div class="col-md-6">
              <input-field
                label="Hourly Rate"
                placeholder="0.00"
                suffix="€"
                [inputFormControl]="getControl('hourlyRate')"
                [type]="'number'"
                [readonly]="false">
              </input-field>
            </div>

            <div class="col-12">
              <div class="form-group mb-1">
                <label class="fw-bold">Row Total</label>
                <div class="input-group shadow-sm">
                  <input type="text" class="form-control" disabled [value]="rowTotal | currency: currency" />
                </div>
              </div>
              <div class="finance-field-hint mt-0">Calculated: Hours Worked × Hourly Rate.</div>
            </div>

            <div class="col-12">
              <textarea-field
                label="Activity Description"
                placeholder="Brief description of the testing activity"
                [textareaFormControl]="getControl('activityDescription')"
                [readonly]="false"
                [height]="80">
              </textarea-field>
            </div>

            <div class="col-md-6">
              <input-field
                label="Date"
                [inputFormControl]="getControl('date')"
                [type]="'date'"
                [readonly]="false">
              </input-field>
            </div>
          </div>
        </div>
      </form>

      <div class="finance-form-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-success" [disabled]="isSaving || isLoading" (click)="save()">Save row</button>
      </div>
    </div>
  </div>
</div>
